// extracted by mini-css-extract-plugin
export default {"caption":"FeedCardImageCommon_caption__LeNYS"};